import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SsrHtmlInjectorService {
  protected platform = inject(PLATFORM_ID);

  protected $document = inject(DOCUMENT);

  public appendBucketPrefetchUrl(bucketUrl: string) {
    const link = this.$document.createElement('link');
    link.rel = 'preconnect';
    link.href = bucketUrl;
    this.$document.head.appendChild(link);
  }

  public appendGoogleTagManager(googleTagManagerId: string): boolean {
    if (isPlatformBrowser(this.platform)) {
      return false;
    }

    const gtmScript = `
      <!-- Google Tag Manager (deferred) -->
      <script async>
        function loadGTM() {
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${googleTagManagerId}');
        }
        if ('requestIdleCallback' in window) {
          requestIdleCallback(loadGTM);
        } else {
          setTimeout(loadGTM, 2000);
        }
      </script>
      <!-- End Google Tag Manager (deferred) -->
    `;

    this.$document.head.innerHTML = this.$document.head.innerHTML + gtmScript;

    const divElement = this.$document.createElement('div');
    const gtmNoScript = `
      <!-- Google Tag Manager (noscript) -->
      <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=${googleTagManagerId}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
      <!-- End Google Tag Manager (noscript) -->
    `;

    divElement.innerHTML = gtmNoScript;

    this.$document.body.appendChild(divElement);

    return true;
  }
}
